import * as Sentry from "@sentry/react";
import { RxStomp } from "@stomp/rx-stomp";
import { useEffect } from "react";
import {
  distinctUntilChanged,
  distinctUntilKeyChanged,
  filter,
  map,
  scan,
} from "rxjs/operators";
import { store } from ".";
import { store$ } from "./utils";
import { BillingActions } from "./billing/actions";
import {
  isFetchableSuccess,
  isFetchableToLoad,
} from "./common/fetchable/helpers";
import { NotificationActions } from "./notifications/actions";

export const useSocket = () =>
  useEffect(() => {
    const client = new RxStomp();

    store$
      .pipe(
        map((x) => x.auth.login),
        distinctUntilKeyChanged("status"),
        filter(isFetchableToLoad)
      )
      .subscribe(() => {
        if (client.active) {
          client.deactivate();
        }
      });

    store$
      .pipe(
        map((x) => x.auth.login),
        filter(isFetchableSuccess),
        filter((auth) => auth.data.accessToken.authenticated),
        map((x) => x.data.raw),
        distinctUntilChanged()
      )
      .subscribe((token) => {
        client.configure({
          brokerURL: `wss://${process.env.REACT_APP_BROKER_URL}/callback/updates`,
          connectHeaders: {
            Authorization: `Bearer ${token}`,
          },
          reconnectDelay: 1024,
          heartbeatIncoming: 4000,
          heartbeatOutgoing: 4000,
        });
        client.activate();
      });

    // Delay reconnect
    client.stompErrors$
      .pipe(scan((acc) => ++acc, 10))
      .subscribe((acc) =>
        client.configure({ reconnectDelay: Math.pow(2, acc) })
      );

    // Log any errors on WS
    client.stompErrors$.subscribe((err) => {
      Sentry.captureException(err);
      store.dispatch(
        NotificationActions.setNotification({
          title: "an-error-on-the-websocket-has-occured",
          variant: "error",
        })
      );
    });

    // Listen to forex rate
    client.watch("/updates/FOREX_RATE_CHANGED").subscribe(({ body }) => {
      try {
        const newForex = JSON.parse(body);
        store.dispatch(
          BillingActions.setForexRate({
            status: "ready",
            data: { rate: newForex.newForexRate },
          })
        );
      } catch (error: any) {
        Sentry.captureException(error);
      }
    });
  }, []);
